import React, { useRef, useState } from 'react';

const FileUpload = ({ onFilesChange, existingFiles = [] }) => {
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const selectedFiles = Array.from(e.target.files);
    processFiles(selectedFiles);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    processFiles(droppedFiles);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const processFiles = (selectedFiles) => {
    const newFiles = [...files];
    const newPreviews = [...previews];

    selectedFiles.forEach(file => {
      newFiles.push(file);
      
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          newPreviews.push({ file, preview: e.target.result });
          setPreviews([...newPreviews]);
        };
        reader.readAsDataURL(file);
      }
    });

    setFiles(newFiles);
    onFilesChange(newFiles);
  };

  const removeFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    const newPreviews = previews.filter((_, i) => i !== index);
    setFiles(newFiles);
    setPreviews(newPreviews);
    onFilesChange(newFiles);
  };

  return (
    <div style={styles.container}>
      <div
        style={styles.dropZone}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={() => fileInputRef.current?.click()}
      >
        <p style={styles.dropZoneText}>
          Drag and drop files here, or click to select
        </p>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />
      </div>

      {files.length > 0 && (
        <div style={styles.fileList}>
          <h4>Selected Files:</h4>
          {files.map((file, index) => (
            <div key={index} style={styles.fileItem}>
              <span>{file.name}</span>
              <button
                type="button"
                onClick={() => removeFile(index)}
                style={styles.removeButton}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}

      {previews.length > 0 && (
        <div style={styles.previewContainer}>
          <h4>Image Previews:</h4>
          <div style={styles.previews}>
            {previews.map((preview, index) => (
              <div key={index} style={styles.previewItem}>
                <img
                  src={preview.preview}
                  alt={`Preview ${index}`}
                  style={styles.previewImage}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {existingFiles && existingFiles.length > 0 && (
        <div style={styles.existingFiles}>
          <h4>Existing Attachments:</h4>
          {existingFiles.map((file) => (
            <div key={file.id} style={styles.fileItem}>
              <span>{file.filename}</span>
              <a
                href={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/uploads/${file.file_path}`}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.downloadLink}
              >
                Download
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    marginTop: '1rem',
  },
  dropZone: {
    border: '2px dashed #ccc',
    borderRadius: '8px',
    padding: '2rem',
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: '#f9f9f9',
    transition: 'all 0.3s',
  },
  dropZoneText: {
    color: '#666',
    margin: 0,
  },
  fileList: {
    marginTop: '1rem',
  },
  fileItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5rem',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    marginTop: '0.5rem',
  },
  removeButton: {
    padding: '0.25rem 0.5rem',
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  previewContainer: {
    marginTop: '1rem',
  },
  previews: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  previewItem: {
    width: '150px',
    height: '150px',
  },
  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '4px',
  },
  existingFiles: {
    marginTop: '1rem',
  },
  downloadLink: {
    color: '#007bff',
    textDecoration: 'none',
  },
};

export default FileUpload;
